<template>
  <div class="org-form" :class="{ 'org-form--dark' : isDarkMode }" v-if="organisation">
    <div
      class="d-flex align-center mb-2 link-default"
      @click="$router.go(-1)"
    >
      <apio-icon
        class="mr-1"
        size="16"
        lightModeColour="cyan"
        name="chevron-left"
      />Back
    </div>

    <div class="org-form__title">{{ organisation.name }}</div>
    <div class="org-form__tabs">
      <div
        class="font-weight-semi-bold mr-6"
        :class="{ 'link-default h4': mode === 'billing-and-usage' }"
        @click="mode = 'details'"
      >
        Details
      </div>
      <div
        class="font-weight-semi-bold"
        :class="{
          'link-default h4': mode === 'details' || mode === 'edit-org',
        }"
        @click="mode = 'billing-and-usage'"
      >
        Billing and Usage
      </div>
    </div>

    <div class="org-form__tab-hr"></div>

    <div
      v-if="mode === 'details'"
      class="org-form__detail-card-wrapper"
    >
      <div class="d-flex flex-wrap">
        <org-details-card
          :class="{ 'details-card--dark': isDarkMode }"
          :org="organisation"
          class="details-card"
          @edit-org="mode = 'edit-org'"
        />
        <!-- <payment-details-card
          :class="{ 'details-card--dark': isDarkMode }"
          :org="organisation"
          class="details-card"
        /> -->
        <company-details-card
          :class="{ 'details-card--dark': isDarkMode }"
          :org="organisation"
          class="details-card"
          @edit-org="mode = 'edit-org'"
        />
      </div>
      <div class="user-permissions-card__title d-flex justify-content">
        <span>
        Users with access to
        </span>
        <span class="ml-2 user-permissions-card__title--org-name">{{
          organisation.name
        }}</span>
        <apio-button
          button-type="secondary"
          slot="button"
          style="text-transform: none"
          class="ml-6 small"
          @click="createNewUsers"
          >Invite users</apio-button
        >
      </div>
      <user-permissions-card :organisation-name="organisation.name" :organisation-hash="organisation.ID" />
    </div>
    <div v-else-if="mode === 'edit-org'">
      <v-card outlined class="edit-new-org__card">
        <div class="edit-new-org__title h3">Organisation Details</div>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <div class="small-extra-bold">Organisation name</div>
            <form-group :validations="$v.organisation.name" class="form-group">
              <div slot-scope="{ errors }">
                <v-text-field
                  :error="true"
                  name="name"
                  dense
                  outlined
                  required
                  v-model="organisation.name"
                  placeholder="Type here..."
                  :hide-details="true"
                >
                </v-text-field>
                <div class="form-field-error">{{ errors && errors[0] }}</div>
              </div>
            </form-group>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <div class="small-extra-bold">Primary contact name</div>
            <form-group
              :validations="$v.organisation.contact_name"
              class="form-group"
            >
              <div slot-scope="{ errors }">
                <v-text-field
                  outlined
                  dense
                  :error="true"
                  id="primary-contact"
                  hide-details="auto"
                  placeholder="Type here..."
                  v-model="$v.organisation.contact_name.$model"
                >
                </v-text-field>
                <div class="form-field-error">{{ errors && errors[0] }}</div>
              </div>
            </form-group>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <div class="small-extra-bold">Email address for invoicing</div>
            <form-group
              :validations="$v.organisation.contact_email"
              class="form-group"
            >
              <div slot-scope="{ errors }">
                <v-text-field
                  outlined
                  dense
                  hide-details="auto"
                  placeholder="Type here..."
                  v-model="$v.organisation.contact_email.$model"
                />
                <div class="form-field-error">
                  {{ (errors && errors[0]) || "" }}
                </div>
              </div>
            </form-group>
          </v-col>

          <v-col cols="12" sm="12" md="6" lg="6">
            <div class="small-extra-bold">Telephone number</div>
            <form-group
              :validations="$v.organisation.contact_number"
              class="form-group"
            >
              <v-text-field
                outlined
                dense
                hide-details="auto"
                placeholder="Type here..."
                v-model="$v.organisation.contact_number.$model"
              >
              </v-text-field>
            </form-group>
          </v-col>
        </v-row>
        <div class="edit-new-org__title h3">Address</div>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <div class="small-extra-bold">Address line 1</div>
            <form-group
              :validations="$v.organisation.address_line_1"
              class="form-group"
            >
              <div slot-scope="{ errors }">
                <v-text-field
                  class=""
                  outlined
                  dense
                  hide-details="auto"
                  placeholder="Type here..."
                  v-model="$v.organisation.address_line_1.$model"
                />
                <div class="form-field-error">{{ errors[0] || "" }}</div>
              </div>
            </form-group>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <div class="small-extra-bold">Address line 2</div>
            <form-group
              :validations="$v.organisation.address_line_2"
              class="form-group"
            >
              <div slot-scope="{ errors }">
                <v-text-field
                  class=""
                  outlined
                  dense
                  hide-details="auto"
                  placeholder="Type here..."
                  v-model="$v.organisation.address_line_2.$model"
                />
                <div class="form-field-error">{{ errors[0] || "" }}</div>
              </div>
            </form-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <div class="small-extra-bold">Town/City</div>
            <form-group :validations="$v.organisation.city" class="form-group">
              <div slot-scope="{ errors }">
                <v-text-field
                  class=""
                  outlined
                  dense
                  hide-details="auto"
                  placeholder="Type here..."
                  v-model="$v.organisation.city.$model"
                />
                <div class="form-field-error">{{ errors[0] || "" }}</div>
              </div>
            </form-group>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <div class="small-extra-bold">Postcode</div>
            <form-group
              :validations="$v.organisation.postcode"
              class="form-group"
            >
              <div slot-scope="{ errors }">
                <v-text-field
                  class=""
                  outlined
                  dense
                  hide-details="auto"
                  placeholder="Type here..."
                  v-model="$v.organisation.postcode.$model"
                />
                <div class="form-field-error">{{ errors[0] || "" }}</div>
              </div>
            </form-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <div class="small-extra-bold" v-if="countries.length">Country</div>
            <vue-select
              v-model="$v.organisation.country_id.$model"
              :options="countries"
              :reduce="(country) => country.ID"
              label="name"
              ref="select"
              placeholder="Select country"
              id="country"
            >
            </vue-select>
          </v-col>
        </v-row>
        <div class="edit-new-org__title h3">Company details</div>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <div class="small-extra-bold">Company registration number</div>
            <form-group
              :validations="$v.organisation.company_registration_number"
              class="form-group"
            >
              <div slot-scope="{ errors }">
                <v-text-field
                  class=""
                  outlined
                  dense
                  hide-details="auto"
                  placeholder="Type here..."
                  v-model="$v.organisation.company_registration_number.$model"
                />
                <div class="form-field-error">{{ errors[0] || "" }}</div>
              </div>
            </form-group>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <div class="small-extra-bold">VAT number</div>
            <form-group
              :validations="$v.organisation.vat_number"
              class="form-group"
            >
              <div slot-scope="{ errors }">
                <v-text-field
                  outlined
                  dense
                  hide-details="auto"
                  placeholder="Type here..."
                  v-model="$v.organisation.vat_number.$model"
                />

                <div class="form-field-error">{{ errors[0] || "" }}</div>
              </div>
            </form-group>
          </v-col>
        </v-row>
      </v-card>
      <div class="edit-new-org__actions">
        <v-spacer></v-spacer>
        <apio-button
          class="mr-2"
          button-type="secondary"
          @click.native="cancel()"
          >Cancel</apio-button
        >
        <apio-button color="primary" :ripple="false" @click="save()"
          >Save</apio-button
        >
      </div>
    </div>
    <div v-else-if="mode === 'billing-and-usage'">
      <div class="mb-2">
        This month's usage:
        <span class="font-weight-semi-bold">{{ monthName }}</span>
      </div>
      <div class="org-form__billing-card-wrapper mb-6">
        <billing-card :name="'STEPS'" :class="{ 'billing-card--dark' : isDarkMode }" :content="totalEventCounts" />
        <billing-card :name="'DATA'" :class="{ 'billing-card--dark' : isDarkMode }" :content="prettySize(totalSize)" />
      </div>
      <div class="mb-2">
        Previous invoices
      </div>
      <invoicing-table :items="billingData" />
    </div>
  </div>
</template>

<script>
import orgs from "@/API/services/orgs";

import { required, minLength, email } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { mapState } from "vuex";

function add(total, num) {
  return total + num;
}

export default {
  name: "OrgForm",
  props: {},
  components: {
    FormGroup: () => import("@/pages/Account/FormGroup"),
    OrgDetailsCard: () => import("@/components/Account/OrgDetailsCard.vue"),
    // PaymentDetailsCard: () =>
    //   import("@/components/Account/PaymentDetailsCard.vue"),
    CompanyDetailsCard: () =>
      import("@/components/Account/CompanyDetailsCard.vue"),
    BillingCard: () => import("@/components/Account/BillingCard.vue"),
    UserPermissionsCard: () => import("@/components/Account/UserPermissionsCard.vue"),
    InvoicingTable: () => import("@/components/Organisations/InvoicingTable.vue")
  },
  validations: {
    organisation: {
      name: {
        required,
        minLength: minLength(4),
      },
      contact_name: {
        minLength: minLength(4),
      },
      contact_email: {
        required,
        email,
      },
      contact_number: {},
      address_line_1: {},
      address_line_2: {},
      city: {},
      postcode: {},
      country_id: {},
      company_registration_number: {},
      vat_number: {},
    },
  },
  mixins: [validationMixin],
  computed: {
    ...mapState({
      username: (state) => state.auth.user,
      user_email: (state) => state.auth.user_email,
    }),
    isFormValid() {
      return !this.$v.$invalid;
    },
    headerText() {
      return `${this.organisation?.name}`;
    },
    monthName() {
      return new Date().toLocaleString(navigator.language, { month: "long" });
    },
    isDarkMode() {
      return this.$store.state.mode.darkMode;
    },
    totalSize() {
      if(this.size.length === 0) return 0;
      return this.size.reduce(add);
    },
    totalEventCounts() {
      if(this.eventCounts.length === 0) return 0;
      return this.eventCounts.reduce(add);
    }
  },
  data() {
    return {
      mode: "details",
      countries: [],
      id: this.$route.params.id,
      organisation: {
        address_line_1: "",
        address_line_2: "",
        card_type: "visa",
        city: "",
        company_registration_number: "",
        contact_email: this.user_email,
        contact_name: this.username,
        contact_number: "",
        country: "",
        country_id: "",
        name: "",
        postcode: "",
        vat_number: "",
      },
      eventCounts: [],
      size: [],
      billingData: [],
      clientUsage: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      await vm.$store.dispatch("fetchSingleOrganisation", vm.id);
      await vm.$store.dispatch("fetchUsers", vm.id);

      vm.organisation = vm.$store.state.orgs.currentOrganisation;
      const [countries] = await Promise.all([orgs.getCountries()]);
      const [billingData] = await Promise.all([orgs.getUserClientBills(vm.id)]);

      vm.billingData = billingData.data || [];
      vm.countries = countries.data;
      vm.organisation.card_type = "visa";
      vm.organisation.country = vm.countries.filter((country) => {
        return country.ID === vm.organisation.country_id;
      });

      vm.calculateBilling();
    });
  },
  methods: {
    async save() {
      if (this.isFormValid) {
        await this.$store.dispatch("editOrganisation", {
          organisation: this.organisation,
        });
        this.mode = "details";
      }
    },
    createNewUsers() {
      if (this.$route.params.id) {
        this.$router.push("/users/add?c="+this.$route.params.id);
      }
    },
    cancel() {
      this.mode = "details";
    },
    async calculateBilling() {
      const { data } = await orgs.getClientUsage({ c: this.id });
      this.clientUsage = data;
      if(!this.clientUsage) return;
      this.clientUsage.forEach(x => {
        this.eventCounts.push(x.EventCount);
        this.size.push(x.Size);
      })
    },
    prettySize(bytes, separator = '', postFix = '') {
      if (bytes) {
          const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
          const i = Math.min(parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString(), 10), sizes.length - 1);
          return `${(bytes / (1024 ** i)).toFixed(i ? 1 : 0)}${separator}${sizes[i]}${postFix}`;
      }
      return '0';
    }
  },
};
</script>

<style lang="scss">
.edit-icon {
  cursor: pointer;
}

.org-form {
  &--dark {
    color: var(--apio-shade-4);
  }

  color: var(--apio-shade-2);
  margin: 0 32px 0 32px;

  @media (max-width: 1024px) {
    margin: 0 20px 0 20px;
  }

  &__detail-card-wrapper {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
  }

  &__billing-card-wrapper {
    display: flex;
    flex-wrap: wrap;
  }

  &__tab-hr {
    width: 100%;
    height: 1px;
    background-color: var(--apio-shade-4);
    margin: 8px 0 24px 0;
  }

  &__tabs {
    width: 100%;
    display: flex;
    align-items: center;
  }

  &__title {
    font-size: var(--font-h1-size);
    font-weight: var(--font-semi-bold);
    width: 100%;

    margin-bottom: 32px;

    @media (max-width: 1024px) {
      font-size: var(--font-h2-size);
      margin-bottom: 16px;
    }
  }
}

.billing-card {
  background: url("/img/brand/card-bg-light.svg");
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;

  &--dark {
    background: url("/img/brand/card-bg-dark.svg");
    color: var(--apio-shade-4);
  }

  color: var(--apio-shade-2);
  width: 292px;
  height: 292px;
  border: 1px solid var(--apio-shade-4);
  border-radius: 4px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 1024px) {
    width: 320px;
    height: 164px;
  }

  &__content {
    font-size: var(--font-hero-size);
    font-weight: var(--font-semi-bold);
  }

  &__name {
    align-items: center;
    background: var(--apio-purple);
    border-radius: 24px !important;
    color: white;
    display: flex;
    font-size: var(--font-paragraph-2-size);
    font-weight: var(--font-extra-bold);
    height: 40px;
    justify-content: center;
    padding: 11px 16px;
    text-align: center;
  }
}

.details-card {
  background: url("/img/brand/card-bg-light.svg");
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  color: var(--apio-shade-2);
  width: 292px;
  height: 292px;
  border: 1px solid var(--apio-shade-4);
  border-radius: 4px;
  padding: 16px;

  &--dark {
    background: url("/img/brand/card-bg-dark.svg");
    color: var(--apio-shade-4);
  }

  @media (max-width: 1024px) {
    width: 320px;
  }

  &__title {
    font-size: var(--font-h3-size);
    font-weight: var(--font-semi-bold);
    margin-bottom: 8px;

    &--main {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    &--sub {
      font-size: var(--font-paragraph-2-size);
    }
  }

  &__body {
    font-size: var(--font-paragraph-2-size);
    &--title {
      font-size: var(--font-paragraph-2-size);
      margin-bottom: 8px;
    }
    &--small-title {
      font-size: var(--font-paragraph-2-size);
      margin-bottom: 4px;
    }
  }
}

.details-card:not(:last-child),
.billing-card:not(:last-child) {
  margin-right: 32px;

  @media (max-width: 1024px) {
    margin-bottom: 16px;
  }
}

.details-card:last-child,
.billing-card:last-child {
  @media (max-width: 1024px) {
    margin-bottom: 40px;
  }
}

.edit-new-org {
  &__card {
    color: var(--apio-shade-2);
    padding: 16px;
    margin: 20px 0;
  }
  &__title {
    padding-bottom: 24px;
  }
  &__title:not(:first-of-type) {
    padding-top: 24px;
  }
  &__header {
    padding-bottom: 24px;
  }
  &__actions {
    margin-bottom: 20px;
    display: flex;
  }
}

.user-permissions-card__title {
    margin-top: 32px;
    font-size: var(--font-h2-size);
    font-weight: var(--font-semi-bold);
    &--org-name {
      color: var(--apio-purple);
    }
}

</style>
